import get from 'lodash.get';
import React, { Fragment } from 'react';

export function getUnique(arr, comp) {
  const unique = arr
    .filter(Boolean) // remove empty items
    .map(e => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter(e => arr[e])
    .map(e => arr[e]);

  return unique;
}

export const getArray = (source, path, empty = []) => {
  const data = get(source, path, empty) || [];
  return data;
};

export const joinElements = (jsxElements, char) =>
  jsxElements.map((jsxElement, elementIndex) =>
    elementIndex > 0 ? (
      <Fragment>
        <span>{char}</span>
        {jsxElement}
      </Fragment>
    ) : (
      jsxElement
    )
  );
